const uuid = require('uuid');
const Reflux = require('@muzzylane/reflux');
const ServerRequest = require('./request');
const ErrorConsts = require('../constants/error');
const ForgeError = require('../util/error');
const GraphUtil = require('../../../app/shared/graph_util');

const AnalyticsActions = Reflux.createActions({
    getChannelOverview: { children: ['completed', 'failed'] },
    getProjectOverview: { children: ['completed', 'failed'] },
    getChannelOverviewRange: { children: ['completed', 'failed'] },
    getProjectOverviewRange: { children: ['completed', 'failed'] },
    getProjectActivitiesRangeTotals: { children: ['started', 'completed', 'failed']},
    getActivityCompletionStats: { children: ['started', 'completed', 'failed'] },
    cancelActivityCompletionStats: { children: ['completed'] },
    getChannelProjectOverview: { children: ['completed',  'failed'] },
    getChannelActivityOverview: { children: ['completed',  'failed'] },
    getChannelCourseStats: { children: ['completed',  'failed'] },
    getChannelCourseNewStudentRange: { children: ['completed',  'failed'] },
    getChannelCourseNewStudentRangePage: { children: ['completed',  'failed'] },
	getChannelCourseNewStudentRangeAllPagesCSV: { children: ['completed',  'failed'] },
    getChannelShareMonthOverview: { children: ['completed',  'failed'] },
    getChannelActivityShareMonthOverview: { children: ['completed',  'failed'] },
    getChannelProjectShareMonthOverview: { children: ['completed',  'failed'] },
	clearChannelCSV: { children: ['completed',  'failed'] },

    getChannelPublishedActCounts: { children: ['completed',  'failed'] },
    getProjectPublishedActCounts: { children: ['completed',  'failed'] },

    getProjectActivityOverview: { children: ['completed',  'failed'] },
    getProjectShortCourseOverview: { children: ['completed',  'failed'] },

    getActivityStatsChannel: { children: ['completed',  'failed'] },
    getShortCourseStatsChannel: { children: ['completed',  'failed'] },
    getChannelActivityOverviewRange: { children: ['completed',  'failed'] },
    getChannelActivityShareRange: { children: ['completed',  'failed'] },
    getProjectShareRange: { children: ['completed',  'failed'] },
    getChannelShareRange: { children: ['completed',  'failed'] },
    getChannelShortCourseOverviewRange: { children: ['completed',  'failed'] },
    getActivityAssignmentStatsChannel: { children: ['completed',  'failed'] },
    getShortCourseInstanceStatsChannel: { children: ['completed',  'failed'] },
    getAssignmentStats: { children: ['completed',  'failed'] },
    getAssignmentRangeStats: { children: ['completed',  'failed'] },
    getNewStudentStatsRange: { children: ['completed', 'failed'] },
    getActivityQlaVersions: { children: ['completed', 'failed'] },
    getActivityQlaUsage: { children: ['completed', 'failed'] },
    getActivityQlaLoUsage: { children: ['completed', 'failed'] },
    getActivityQlaQuestionSummary: { children: ['completed', 'failed'] },
    getActivityQlaQuestionDetails: { children: ['completed', 'failed'] },
    getAssnActQlaUsage: { children: ['completed', 'failed'] },
    getAssnActWeights: { children: ['completed', 'failed'] },
    getAssnActQlaLoUsage: { children: ['completed', 'failed'] },
    getAssnActQlaQuestionSummary: { children: ['completed', 'failed'] },
    getAssnActQlaQuestionDetails: { children: ['completed', 'failed'] },

    getAssnQlaUsage: { children: ['completed', 'failed'] },
    getAssnQlaLoUsage: { children: ['completed', 'failed'] },
    getAssnQlaQuestionSummary: { children: ['completed', 'failed'] },
    getAssnQlaQuestionDetails: { children: ['completed', 'failed'] },
    getChannelActivityCustomAnalytics: { children: ['completed', 'failed'] },
    
    getShortCourseInstanceStats: { children: ['completed',  'failed'] },
});

AnalyticsActions.getChannelOverview.listen(function(actionID, params) {
    const self = this;

    if(!params.id) {
        this.failed(actionID, params.id, new ForgeError({message: ErrorConsts.MISSING_PARAMS}));
        return;
    }

    ServerRequest.makeTaskRequest(`/authoring/analytics/channel/${params.id}/overview`, 'GET')
        .then(function(res) {self.completed(actionID, params.id, res)})
        .catch(function(err) {self.failed(actionID, params.id, err)});
});

AnalyticsActions.getProjectOverview.listen(function(actionID, params) {
    const self = this;

    if (!params.id) {
        this.failed(actionID, params.id, new ForgeError({message: ErrorConsts.MISSING_PARAMS}));
        return;
    }

    ServerRequest.makeTaskRequest(`/authoring/analytics/project/${params.id}/overview`, 'GET')
        .then(function(res) { self.completed(actionID, params.id, res); })
        .catch(function(err) { self.failed(actionID, params.id, err); });
});

AnalyticsActions.getChannelOverviewRange.listen(function(actionID, params, manager) {
    if (!params.id) {
        this.failed(actionID, params.id, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (params.startDate > params.endDate) {
        this.failed(actionID, params.id, new ForgeError({ message: ErrorConsts.INVALID_DATE_RANGE }));
        return;
    }

    const startDate = params.startDate.format('YYYY-MM-DD');
    const endDate = params.endDate.format('YYYY-MM-DD');
    ServerRequest.makePollTaskRequest(`/authoring/analytics/channel/${params.id}/overview_range`, 'POST', JSON.stringify({
            start_date: startDate,
            end_date: endDate
        }),manager, actionID)
        .then((res) => {
            res.timeseriesCol = GraphUtil.generateTimeseriesColumn(startDate, endDate, 'x'); // no longer returned by server
            return this.completed(actionID, params.id, res, startDate, endDate)
        })
        .catch(err => this.failed(actionID, params.id, err));
});

AnalyticsActions.getProjectOverviewRange.listen(function(actionID, params, manager) {
    const self = this;

    if (!params.id) {
        this.failed(actionID, params.id, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (params.startDate > params.endDate) {
        this.failed(actionID, params.id, new ForgeError({ message: ErrorConsts.INVALID_DATE_RANGE }));
        return;
    }

    let startDate = params.startDate.format('YYYY-MM-DD');
    let endDate = params.endDate.format('YYYY-MM-DD');

    ServerRequest.makePollTaskRequest(`/authoring/analytics/project/${params.id}/overview_range`, 'POST', JSON.stringify({
            start_date: startDate,
            end_date: endDate
        }), manager, actionID)
        .then(function(res) { self.completed(actionID, params.id, res); })
        .catch(function(err) { self.failed(actionID, params.id, err); });
});

AnalyticsActions.getProjectActivitiesRangeTotals.listen(function(actionId, params, manager) {
    const self = this;
    if (!params.projectId) {
        this.failed(actionId, null, null, null, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (!params.channelId) {
        this.failed(actionId, params.projectId, null, null, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    const startDate = params.startDate.format('YYYY-MM-DD');
    const endDate = params.endDate.format('YYYY-MM-DD');
    if (params.startDate > params.endDate) { // do check on moment objects
        this.failed(actionId, params.projectId, startDate, endDate, new ForgeError({ message: ErrorConsts.INVALID_DATE_RANGE }));
        return;
    }

    this.started(actionId, params.projectId, startDate, endDate);
    ServerRequest.makePollTaskRequest(`/authoring/analytics/channel/${params.channelId}/project/${params.projectId}/activity/overview_range_totals`, 'POST', JSON.stringify({
            start_date: startDate,
            end_date: endDate
        }), manager, actionId)
        .then(res => self.completed(actionId, params.projectId, startDate, endDate, res))
        .catch(err => self.failed(actionId, params.projectId, startDate, endDate, err));
});

AnalyticsActions.getActivityCompletionStats.listen(function(actionId, params, manager) {
    if (!params.activityId) {
        this.failed(actionId, null, null, null, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (!params.channelId) {
        this.failed(actionId, params.activityId, null, null, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    const startDate = params.startDate.format('YYYY-MM-DD');
    const endDate = params.endDate.format('YYYY-MM-DD');
    if (params.startDate > params.endDate) { // do check on moment objects
        this.failed(actionId, params.activityId, startDate, endDate, new ForgeError({ message: ErrorConsts.INVALID_DATE_RANGE }));
        return;
    }

    this.started(actionId, params.activityId, startDate, endDate);
    ServerRequest.makePollTaskRequest(`/authoring/analytics/channel/${params.channelId}/activity/${params.activityId}/completion_stats_range`, 'POST', JSON.stringify({
            start_date: startDate,
            end_date: endDate
        }), manager, actionId)
        .then(res => this.completed(actionId, params.activityId, startDate, endDate, res))
        .catch(err => this.failed(actionId, params.activityId, startDate, endDate, err));
});

AnalyticsActions.cancelActivityCompletionStats.listen(function(actionId) {
    this.completed(actionId);
});

AnalyticsActions.getChannelProjectOverview.listen(function(actionID, params) {
    const self = this;

    if (!params.id) {
        this.failed(actionID, params.id, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/analytics/channel/${params.id}/project/overview`, 'GET')
        .then(function(res) { self.completed(actionID, params.id, res) })
        .catch(function(err) { self.failed(actionID, params.id, err) });
});

AnalyticsActions.getChannelActivityOverview.listen(function(actionID, params) {
    const self = this;

    if(!params.id) {
        this.failed(actionID, params.id, new ForgeError({message: ErrorConsts.MISSING_PARAMS}));
        return;
    }

    ServerRequest.makeRequest(`/authoring/analytics/channel/${params.id}/activity/overview`, 'GET')
        .then(function(res) {self.completed(actionID, params.id, res)})
        .catch(function(err) {self.failed(actionID, params.id, err)});
});

AnalyticsActions.getChannelCourseStats.listen(function(actionID, params) {
    const self = this;

    if(!params.id) {
        this.failed(actionID, params.id, new ForgeError({message: ErrorConsts.MISSING_PARAMS}));
        return;
    }

    ServerRequest.makeRequest(`/authoring/analytics/channel/${params.id}/course/overview`, 'GET')
        .then(function(res) {self.completed(actionID, params.id, res)})
        .catch(function(err) {self.failed(actionID, params.id, err)});
});

AnalyticsActions.getChannelCourseNewStudentRange.listen(function(actionID, params, manager) {
    const self = this;

    if(!params.id || !params.startDate || !params.endDate) {
        this.failed(actionID, params.id, new ForgeError({message: ErrorConsts.MISSING_PARAMS}));
        return;
    }
    
    let startDate = params.startDate.format('YYYY-MM-DD');
    let endDate = params.endDate.format('YYYY-MM-DD');
    let studentPage = params.studentPage;

    ServerRequest.makePollTaskRequest(`/authoring/analytics/channel/${params.id}/course/new_student_range`, 'POST', JSON.stringify({
        start_date: startDate,
        end_date: endDate
    }),manager, actionID)
    .then(function(res) {self.completed(actionID, params.id, res)})
    .catch(function(err) {self.failed(actionID, params.id, err)});
});

AnalyticsActions.getChannelCourseNewStudentRangePage.listen(function(actionID, params) {
    const self = this;

    if(!params.id || !params.startDate || !params.endDate) {
        this.failed(actionID, params.id, new ForgeError({message: ErrorConsts.MISSING_PARAMS}));
        return;
    }
    
    let startDate = params.startDate.format('YYYY-MM-DD');
    let endDate = params.endDate.format('YYYY-MM-DD');
    let studentPage = params.studentPage;

    ServerRequest.makeRequest(`/authoring/analytics/channel/${params.id}/course/new_student_range_page`, 'POST', JSON.stringify({
        start_date: startDate,
        end_date: endDate,
        student_page: studentPage, // course, assignment and page number for students (otherwise only student counts will be returned)
    }))
    .then(function(res) {
        self.completed(actionID, params.id, params.course_id, params.studentPage.assignment_id, res);
    })
    .catch(function(err) {
        self.failed(  actionID, params.id, params.course_id, params.studentPage.assignment_id, err);
    });
});

AnalyticsActions.getChannelCourseNewStudentRangeAllPagesCSV.listen(function(actionID, params) {
    const self = this;

    if(!params.id || !params.startDate || !params.endDate) {
        this.failed(actionID, params.id, new ForgeError({message: ErrorConsts.MISSING_PARAMS}));
        return;
    }

    let startDate = params.startDate.format('YYYY-MM-DD');
    let endDate = params.endDate.format('YYYY-MM-DD');
	let request_id = uuid.v4(); // to avoid conflict with same channel requests from elsewhere

    ServerRequest.makeTaskRequest(`/authoring/analytics/channel/${params.id}/course/new_student_range_all_students_csv`, 'POST', JSON.stringify({
        start_date: startDate,
        end_date: endDate,
		students_per_page: params.studentsPerPage,
		request_id,
    }))
    .then(function(res) {self.completed(actionID, params.id, res)})
    .catch(function(err) {self.failed(actionID, params.id, err)});
});

// date: YYYY-MM format
AnalyticsActions.getChannelShareMonthOverview.listen(function(actionId, params, manager) {
    if (!params.channelId || !params.date) {
        this.failed(actionId, null, null, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makePollTaskRequest(`/authoring/analytics/channel/${params.channelId}/share_month_overview`, 'POST', JSON.stringify({
            date: params.date
        }), manager, actionId)
        .then(res => this.completed(actionId, params.channelId, params.date, res))
        .catch(err => this.failed(actionId, params.channelId, params.date, err));
});

// date: YYYY-MM format
// admin only
AnalyticsActions.getChannelActivityShareMonthOverview.listen(function(actionId, params, manager) {
    if (!params.channelId || !params.activityId || !params.date) {
        this.failed(actionId, null, null, null, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makePollTaskRequest(`/authoring/analytics/channel/${params.channelId}/activity/${params.activityId}/share_month_overview`, 'POST', JSON.stringify({
            date: params.date
        }), manager, actionId)
        .then(res => this.completed(actionId, params.channelId, params.activityId, params.date, res))
        .catch(err => this.failed(actionId, params.channelId, params.activityId, params.date, err));
});

// date: YYYY-MM format
// admin only
AnalyticsActions.getChannelProjectShareMonthOverview.listen(function(actionId, params, manager) {
    if (!params.channelId || !params.projectId || !params.date) {
        this.failed(actionId, null, null, null, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makePollTaskRequest(`/authoring/analytics/channel/${params.channelId}/project/${params.projectId}/share_month_overview`, 'POST', JSON.stringify({
            date: params.date
        }), manager, actionId)
        .then(res => this.completed(actionId, params.channelId, params.projectId, params.date, res))
        .catch(err => this.failed(actionId, params.channelId, params.projectId, params.date, err));
});

AnalyticsActions.getChannelActivityCustomAnalytics.listen(function(actionID, params) {
    const self = this;
    if(!params.channelId || !params.activityId || !params.version) {
        this.failed(actionID, params, new ForgeError({message: ErrorConsts.MISSING_PARAMS}));
        return;
    }
	const request_id = uuid.v4(); // to avoid conflict with same channel requests from elsewhere
    const version = params.version;

    ServerRequest.makeTaskRequest(`/authoring/analytics/channel/${params.channelId}/activity/${params.activityId}/custom_analytics_csv`, 'POST', JSON.stringify({
        version,
		request_id, 
    }))
    .then(function(res) {self.completed(actionID, params, res)})
    .catch(function(err) {self.failed(actionID, params, err)});
});

AnalyticsActions.clearChannelCSV.listen(function(actionID, params) {
    const self = this;

    if(!params.id || !params.csv_filename) {
        this.failed(actionID, params.id, new ForgeError({message: ErrorConsts.MISSING_PARAMS}));
        return;
    }

    ServerRequest.makeRequest(`/authoring/analytics/channel/${params.id}/csv/${params.csv_filename}`, 'DELETE')
    .then(function(res) {self.completed(actionID, params.id, params.csv_filename, res)})
    .catch(function(err) {self.failed(actionID, params.id, err)});
});

AnalyticsActions.getChannelPublishedActCounts.listen(function(actionId, params) {
    if (!params.id) {
        this.failed(actionId, params.id, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/analytics/channel/${params.id}/published_activities`, 'GET')
        .then(res => this.completed(actionId, params.id, res))
        .catch(err => this.failed(actionId, params.id, err));
});

AnalyticsActions.getProjectPublishedActCounts.listen(function(actionId, params) {
    if (!params.id) {
        this.failed(actionId, params.id, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/analytics/project/${params.id}/published_activities`, 'GET')
        .then(res => this.completed(actionId, params.id, res))
        .catch(err => this.failed(actionId, params.id, err));
});

AnalyticsActions.getProjectActivityOverview.listen(function(actionID, params) {
    const self = this;

    if (!params.id) {
        this.failed(actionID, params.id, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeTaskRequest(`/authoring/analytics/project/${params.id}/activity/overview`, 'GET')
        .then(function(res) { self.completed(actionID, params.id, res) })
        .catch(function(err) { self.failed(actionID, params.id, err) });
});

AnalyticsActions.getProjectShortCourseOverview.listen(function(actionID, params) {
    if (!params.id) {
        this.failed(actionID, params.id, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeTaskRequest(`/authoring/analytics/project/${params.id}/short_course/overview`, 'GET')
        .then(res => this.completed(actionID, params.id, res))
        .catch(err => this.failed(actionID, params.id, err));
});

// get stats for a specific activity from the context of a user with channel permissions (not project owner/collab)
AnalyticsActions.getActivityStatsChannel.listen(function(actionID, params) {
    const self = this;

    if(!params.channelId || !params.activityId) {
        this.failed(actionID, params.activityId, new ForgeError({message: ErrorConsts.MISSING_PARAMS}));
        return;
    }

    ServerRequest.makeTaskRequest(`/authoring/analytics/channel/${params.channelId}/activity/${params.activityId}/stats`, 'GET')
        .then(function(res) {self.completed(actionID, params.activityId, res)})
        .catch(function(err) {self.failed(actionID, params.activityId, err)});
});

AnalyticsActions.getShortCourseStatsChannel.listen(function(actionId, params) {
    if (!params.channelId || !params.shortCourseId) {
        this.failed(actionId, params.shortCourseId, new ForgeError({message: ErrorConsts.MISSING_PARAMS}));
        return;
    }

    ServerRequest.makeTaskRequest(`/authoring/analytics/channel/${params.channelId}/short_course/${params.shortCourseId}/stats`, 'GET')
        .then(res => this.completed(actionId, params.shortCourseId, res))
        .catch(err => this.failed(actionId, params.shortCourseId, err));
});

AnalyticsActions.getChannelActivityOverviewRange.listen(function(actionID, params) {
    const self = this;

    if(!params.channelId || !params.activityId) {
        this.failed(actionID, params.activityId, new ForgeError({message: ErrorConsts.MISSING_PARAMS}));
        return;
    }

    if(params.startDate > params.endDate) {
        this.failed(actionID, params.activityId, new ForgeError({message: ErrorConsts.INVALID_DATE_RANGE}));
        return;
    }

    let startDate = params.startDate.format('YYYY-MM-DD');
    let endDate = params.endDate.format('YYYY-MM-DD');

    ServerRequest.makeTaskRequest(`/authoring/analytics/channel/${params.channelId}/activity/${params.activityId}/overview_range`, 'POST', JSON.stringify({
            start_date: startDate,
            end_date: endDate
        }))
        .then(function(res) {self.completed(actionID, params.activityId, res)})
        .catch(function(err) {self.failed(actionID, params.activityId, err)});
});

AnalyticsActions.getChannelActivityShareRange.listen(function(actionId, params) {
    if (!params.channelId || !params.activityId || !params.startDate || !params.endDate) {
        this.failed(actionId, params.activityId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (params.startDate > params.endDate) {
        this.failed(actionId, params.activityId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    const startDate = params.startDate.format('YYYY-MM-DD');
    const endDate = params.endDate.format('YYYY-MM-DD');
    ServerRequest.makeTaskRequest(
            `/authoring/analytics/channel/${params.channelId}/activity/${params.activityId}/share_range`,
            'POST',
            JSON.stringify({
                start_date: startDate,
                end_date: endDate
            })
        )
        .then(res => this.completed(actionId, params.activityId, res))
        .catch(err => this.failed(actionId, params.activityId, err));
});

AnalyticsActions.getProjectShareRange.listen(function(actionId, params) {
    if (!params.projectId || !params.startDate || !params.endDate) {
        this.failed(actionId, params.projectId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (params.startDate > params.endDate) {
        this.failed(actionId, params.projectId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    const startDate = params.startDate.format('YYYY-MM-DD');
    const endDate = params.endDate.format('YYYY-MM-DD');
    ServerRequest.makeTaskRequest(
            `/authoring/analytics/project/${params.projectId}/share_range`,
            'POST',
            JSON.stringify({
                start_date: startDate,
                end_date: endDate
            })
        )
        .then(res => this.completed(actionId, params.projectId, res))
        .catch(err => this.failed(actionId, params.projectId, err));
});

AnalyticsActions.getChannelShareRange.listen(function(actionId, params) {
    if (!params.channelId || !params.startDate || !params.endDate) {
        this.failed(actionId, params.channelId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (params.startDate > params.endDate) {
        this.failed(actionId, params.channelId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    const startDate = params.startDate.format('YYYY-MM-DD');
    const endDate = params.endDate.format('YYYY-MM-DD');
    ServerRequest.makeTaskRequest(
            `/authoring/analytics/channel/${params.channelId}/share_range`,
            'POST',
            JSON.stringify({
                start_date: startDate,
                end_date: endDate
            })
        )
        .then(res => this.completed(actionId, params.channelId, res))
        .catch(err => this.failed(actionId, params.channelId, err));
});

AnalyticsActions.getChannelShortCourseOverviewRange.listen(function(actionId, params) {
    if (!params.channelId || !params.shortCourseId) {
        this.failed(actionId, params.shortCourseId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (params.startDate > params.endDate) {
        this.failed(actionId, params.shortCourseId, new ForgeError({ message: ErrorConsts.INVALID_DATE_RANGE }));
        return;
    }

    const startDate = params.startDate.format('YYYY-MM-DD');
    const endDate = params.endDate.format('YYYY-MM-DD');
    ServerRequest.makeTaskRequest(`/authoring/analytics/channel/${params.channelId}/short_course/${params.shortCourseId}/overview_range`, 'POST', JSON.stringify({
            start_date: startDate,
            end_date: endDate
        }))
        .then(res => this.completed(actionId, params.shortCourseId, res))
        .catch(err => this.failed(actionId, params.shortCourseId, err));
});

// get assignments w/ stats for a specific activity from the context of a user with channel permissions
AnalyticsActions.getActivityAssignmentStatsChannel.listen(function(actionID, params) {
    const self = this;

    if(!params.channelId || !params.activityId) {
        this.failed(actionID, params.activityId, new ForgeError({message: ErrorConsts.MISSING_PARAMS}));
        return;
    }

    ServerRequest.makeTaskRequest(`/authoring/analytics/channel/${params.channelId}/activity/${params.activityId}/assignments`, 'GET')
        .then(function(res) {self.completed(actionID, params.activityId, res)})
        .catch(function(err) {self.failed(actionID, params.activityId, err)});
});

AnalyticsActions.getShortCourseInstanceStatsChannel.listen(function(actionId, params) {
    if (!params.channelId || !params.shortCourseId) {
        this.failed(actionId, params.shortCourseId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeTaskRequest(`/authoring/analytics/channel/${params.channelId}/short_course/${params.shortCourseId}/course_instances`, 'GET')
        .then(res => this.completed(actionId, params.shortCourseId, res))
        .catch(err => this.failed(actionId, params.shortCourseId, err));
});

// get assignments stats for a specific assignment from the context of an instructor or user with channel permissions
AnalyticsActions.getAssignmentStats.listen(function(actionID, params) {
    const self = this;

    if(!params.assignmentHash) {
        this.failed(actionID, params.assignmentHash, new ForgeError({message: ErrorConsts.MISSING_PARAMS}));
        return;
    }

    ServerRequest.makeTaskRequest(`/authoring/analytics/assignment/${params.assignmentHash}/stats`, 'GET')
        .then(function(res) {self.completed(actionID, params.assignmentHash, res)})
        .catch(function(err) {self.failed(actionID, params.assignmentHash, err)});
});

AnalyticsActions.getAssignmentRangeStats.listen(function(actionID, params) {
    const self = this;

    if (!params.assignmentHash) {
        this.failed(actionID, params.assignmentHash, new ForgeError({message: ErrorConsts.MISSING_PARAMS}));
        return;
    }

    let queryString = '';
    if (params.userHash && params.attemptNum) {
        queryString = `?userHash=${params.userHash}&attemptNum=${params.attemptNum}`;
    }

    ServerRequest.makeRequest(`/authoring/analytics/assignment/${params.assignmentHash}/sc_range_stats${queryString}`, 'GET')
        .then(res => self.completed(actionID, params.assignmentHash, res))
        .catch(err => self.failed(actionID, params.assignmentHash, err));
});

// New student stats for an organization for some date range
AnalyticsActions.getNewStudentStatsRange.listen(function(actionId, params,manager) {
    if (!params.orgId) {
        this.failed(actionId, params.activityId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (!params.startDate || !params.endDate) {
        this.failed(actionId, params.activityId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (params.startDate > params.endDate) {
        this.failed(actionId, params.activityId, new ForgeError({ message: ErrorConsts.INVALID_DATE_RANGE }));
        return;
    }

    const startDate = params.startDate.format('YYYY-MM-DD');
    const endDate = params.endDate.format('YYYY-MM-DD');
    ServerRequest.makePollTaskRequest(`/authoring/organization/${params.orgId}/student_stats`, 'POST', JSON.stringify({
            start_date: startDate,
            end_date: endDate
        }),manager, actionId)
        .then((res) => {
            // regenerate timeseriesCol (server no longer returns it)
            let timeseriesCol = GraphUtil.generateTimeseriesColumn(startDate, endDate, 'x');
            let graphData = { 
                timeseriesCol,
                ...res.graphData
            };
            res.graphData = graphData;
            return this.completed(actionId, params.orgId, res, startDate, endDate);
        })
        .catch(err => this.failed(actionId, params.orgId, err));
});

AnalyticsActions.getActivityQlaVersions.listen(function(actionId, params) {
    if (!params.channelId) {
        this.failed(actionId, params.activityId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (!params.activityId) {
        this.failed(actionId, params.activityId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/analytics/channel/${params.channelId}/activity/${params.activityId}/qla_versions`, 'GET')
        .then(res => this.completed(actionId, params.activityId, res))
        .catch(err => this.failed(actionId, params.activityId, err));
});

AnalyticsActions.getActivityQlaUsage.listen(function(actionId, params) {
    if (!params.channelId) {
        this.failed(actionId, params.activityId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (!params.activityId) {
        this.failed(actionId, params.activityId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (!params.minVersion || !params.maxVersion) {
        this.failed(actionId, params.activityId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }    

    ServerRequest.makeRequest(`/authoring/analytics/channel/${params.channelId}/activity/${params.activityId}/qla_usage`, 'POST', JSON.stringify({
            minVersion: params.minVersion,
            maxVersion: params.maxVersion
        }))
        .then(res => this.completed(actionId, params.activityId, res))
        .catch(err => this.failed(actionId, params.activityId, err));
});

AnalyticsActions.getActivityQlaLoUsage.listen(function(actionId, params) {
    if (!params.channelId) {
        this.failed(actionId, params.activityId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (!params.activityId) {
        this.failed(actionId, params.activityId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (!params.minVersion || !params.maxVersion) {
        this.failed(actionId, params.activityId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }    

    ServerRequest.makeRequest(`/authoring/analytics/channel/${params.channelId}/activity/${params.activityId}/qla_lo_usage`, 'POST', JSON.stringify({
            minVersion: params.minVersion,
            maxVersion: params.maxVersion
        }))
        .then(res => this.completed(actionId, params.activityId, res))
        .catch(err => this.failed(actionId, params.activityId, err));
});

AnalyticsActions.getActivityQlaQuestionSummary.listen(function(actionId, params) {
    if (!params.channelId) {
        this.failed(actionId, params.activityId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (!params.activityId) {
        this.failed(actionId, params.activityId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (!params.minVersion || !params.maxVersion) {
        this.failed(actionId, params.activityId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }    

    ServerRequest.makeRequest(`/authoring/analytics/channel/${params.channelId}/activity/${params.activityId}/qla_question_summary`, 'POST', JSON.stringify({
            minVersion: params.minVersion,
            maxVersion: params.maxVersion
        }))
        .then(res => this.completed(actionId, params.activityId, res))
        .catch(err => this.failed(actionId, params.activityId, err));
});

AnalyticsActions.getActivityQlaQuestionDetails.listen(function(actionId, params) {
    if (!params.channelId) {
        this.failed(actionId, params.activityId, params.questionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (!params.activityId) {
        this.failed(actionId, params.activityId, params.questionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (!params.minVersion || !params.maxVersion) {
        this.failed(actionId, params.activityId, params.questionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (!params.questionId) {
        this.failed(actionId, params.activityId, params.questionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (!params.questionType) {
        this.failed(actionId, params.activityId, params.questionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/analytics/channel/${params.channelId}/activity/${params.activityId}/qla_question_details`, 'POST', JSON.stringify({
            minVersion: params.minVersion,
            maxVersion: params.maxVersion,
            questionId: params.questionId,
            questionType: params.questionType,
        }))
        .then(res => this.completed(actionId, params.activityId, params.questionId, res))
        .catch(err => this.failed(actionId, params.activityId, params.questionId, err));
});

// "empty" analytics for specified activity/version ---------------------------
AnalyticsActions.getAssnActQlaUsage.listen(function(actionId, params) {
    if (!params.assignmentHash) {
        this.failed(actionId, null, null, new ForgeError(({ message: ErrorConsts.MISSING_PARAMS })));
        return;
    }

    if (!params.activityId) {
        this.failed(actionId, params.assignmentHash, null, new ForgeError(({ message: ErrorConsts.MISSING_PARAMS })));
        return;
    }

    ServerRequest.makeRequest(`/authoring/analytics/assignment/${params.assignmentHash}/qla_usage`, 'POST', JSON.stringify({
            activity_id: params.activityId,
            activity_version: params.activityVersion,
        }))
        .then(res => this.completed(actionId, params.assignmentHash, params.activityId, res))
        .catch(err => this.failed(actionId, params.assignmentHash, err));
});

AnalyticsActions.getAssnActWeights.listen(function(actionId, params) {
    if (!params.assignmentHash) {
        this.failed(actionId, null, null, new ForgeError(({ message: ErrorConsts.MISSING_PARAMS })));
        return;
    }

    if (!params.activityId) {
        this.failed(actionId, params.assignmentHash, null, null, new ForgeError(({ message: ErrorConsts.MISSING_PARAMS })));
        return;
    }

    ServerRequest.makeRequest(`/authoring/analytics/assignment/${params.assignmentHash}/qla_weights`, 'POST', JSON.stringify({
            activity_id: params.activityId,
            activity_version: params.activityVersion || "",
        }))
        .then(res => this.completed(actionId, params.assignmentHash, params.activityId, params.activityVersion, res))
        .catch(err => this.failed(actionId, params.assignmentHash, params.activityId, params.activityVersion, err));
});

AnalyticsActions.getAssnActQlaLoUsage.listen(function(actionId, params) {
    if (!params.assignmentHash) {
        this.failed(actionId, null, null, new ForgeError(({ message: ErrorConsts.MISSING_PARAMS })));
        return;
    }

    if (!params.activityId) {
        this.failed(actionId, params.assignmentHash, null, new ForgeError(({ message: ErrorConsts.MISSING_PARAMS })));
        return;
    }

    ServerRequest.makeRequest(`/authoring/analytics/assignment/${params.assignmentHash}/qla_lo_usage`, 'POST', JSON.stringify({
            activity_id: params.activityId,
            activity_version: params.activityVersion,
        }))
        .then(res => this.completed(actionId, params.assignmentHash, params.activityId, res))
        .catch(err => this.failed(actionId, params.assignmentHash, err));
});

AnalyticsActions.getAssnActQlaQuestionSummary.listen(function(actionId, params) {
    if (!params.assignmentHash) {
        this.failed(actionId, null, null, new ForgeError(({ message: ErrorConsts.MISSING_PARAMS })));
        return;
    }

    if (!params.activityId) {
        this.failed(actionId, params.assignmentHash, null, new ForgeError(({ message: ErrorConsts.MISSING_PARAMS })));
        return;
    }

    ServerRequest.makeRequest(`/authoring/analytics/assignment/${params.assignmentHash}/qla_question_summary`, 'POST', JSON.stringify({
            activity_id: params.activityId,
            activity_version: params.activityVersion,
        }))
        .then(res => this.completed(actionId, params.assignmentHash, params.activityId, res))
        .catch(err => this.failed(actionId, params.assignmentHash, params.activityId, err));
});

AnalyticsActions.getAssnActQlaQuestionDetails.listen(function(actionId, params) {
    if (!params.assignmentHash) {
        this.failed(actionId, null, null, new ForgeError(({ message: ErrorConsts.MISSING_PARAMS })));
        return;
    }

    if (!params.activityId) {
        this.failed(actionId, params.assignmentHash, null, null, new ForgeError(({ message: ErrorConsts.MISSING_PARAMS })));
        return;
    }

    if (!params.questionId) {
        this.failed(actionId, params.assignmentHash, params.activityId, null, new ForgeError(({ message: ErrorConsts.MISSING_PARAMS })));
        return;
    }

    if (!params.questionType) {
        this.failed(actionId, params.assignmentHash, params.activityId, params.questionId, new ForgeError(({ message: ErrorConsts.MISSING_PARAMS })));
        return;
    }

    ServerRequest.makeRequest(`/authoring/analytics/assignment/${params.assignmentHash}/qla_question_details`, 'POST', JSON.stringify({
            activity_id: params.activityId,
            activity_version: params.activityVersion,
            questionId: params.questionId,
            questionType: params.questionType,
        }))
        .then(res => this.completed(actionId, params.assignmentHash, params.activityId, params.questionId, res))
        .catch(err => this.failed(actionId, params.assignmentHash, params.activityId, params.questionId, err));
});
// end "empty" analytics ------------------------------------------------------

// analytics for set assignment activity --------------------------------------
AnalyticsActions.getAssnQlaUsage.listen(function(actionId, params) {
    if (!params.assignmentHash) {
        this.failed(actionId, null, new ForgeError(({ message: ErrorConsts.MISSING_PARAMS })));
        return;
    }

    ServerRequest.makeRequest(`/authoring/analytics/assignment/${params.assignmentHash}/qla_usage`, 'GET')
        .then(res => this.completed(actionId, params.assignmentHash, res))
        .catch(err => this.failed(actionId, params.assignmentHash, err));
});

AnalyticsActions.getAssnQlaLoUsage.listen(function(actionId, params) {
    if (!params.assignmentHash) {
        this.failed(actionId, null, new ForgeError(({ message: ErrorConsts.MISSING_PARAMS })));
        return;
    }

    ServerRequest.makeRequest(`/authoring/analytics/assignment/${params.assignmentHash}/qla_lo_usage`, 'GET')
        .then(res => this.completed(actionId, params.assignmentHash, res))
        .catch(err => this.failed(actionId, params.assignmentHash, err));
});

AnalyticsActions.getAssnQlaQuestionSummary.listen(function(actionId, params) {
    if (!params.assignmentHash) {
        this.failed(actionId, null, new ForgeError(({ message: ErrorConsts.MISSING_PARAMS })));
        return;
    }

    ServerRequest.makeRequest(`/authoring/analytics/assignment/${params.assignmentHash}/qla_question_summary`, 'GET')
        .then(res => this.completed(actionId, params.assignmentHash, res))
        .catch(err => this.failed(actionId, params.assignmentHash, err));
});

AnalyticsActions.getAssnQlaQuestionDetails.listen(function(actionId, params) {
    if (!params.assignmentHash) {
        this.failed(actionId, null, null, new ForgeError(({ message: ErrorConsts.MISSING_PARAMS })));
        return;
    }

    if (!params.questionId) {
        this.failed(actionId, params.assignmentHash, null, new ForgeError(({ message: ErrorConsts.MISSING_PARAMS })));
        return;
    }

    if (!params.questionType) {
        this.failed(actionId, params.assignmentHash, params.questionId, new ForgeError(({ message: ErrorConsts.MISSING_PARAMS })));
        return;
    }

    ServerRequest.makeRequest(`/authoring/analytics/assignment/${params.assignmentHash}/qla_question_details/${params.questionType}/${params.questionId}`, 'GET')
        .then(res => this.completed(actionId, params.assignmentHash, params.questionId, res))
        .catch(err => this.failed(actionId, params.assignmentHash, params.questionId, err));
});
// end set assn activity analytics --------------------------------------------

// get stats for a specific short course instance from the context of an instructor or user with channel permissions
AnalyticsActions.getShortCourseInstanceStats.listen(function(actionId, params) {
    if (!params.instanceHash) {
        this.failed(actionId, params.instanceHash, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeTaskRequest(`/authoring/analytics/short_course_instance/${params.instanceHash}/stats`, 'GET')
        .then(res => this.completed(actionId, params.instanceHash, res))
        .catch(err => this.failed(actionId, params.instanceHash, err));
});

module.exports = AnalyticsActions;
